"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var createBuildConfig_exports = {};
__export(createBuildConfig_exports, {
  default: () => createBuildConfig
});
module.exports = __toCommonJS(createBuildConfig_exports);
function createBuildConfig() {
  return {
    transpile: [
      "@webplatform/asbis-ui",
      "@webplatform/cdn-image",
      "@webplatform/nuxt-cms-js-sdk",
      "@webplatform/dev-tools",
      "@webplatform/frontkit",
      "@vueform/multiselect",
      "vue-youtube-embed",
      "ohash",
      "@shoelace-style",
      "@lit",
      "lit-html",
      "lit-element"
    ],
    extend(config, { isClient }) {
      if (isClient) {
        config.devtool = "source-map";
      }
      config.module.rules.push({
        test: /\.[m|c]js$/,
        include: [
          /node_modules\/h3/,
          /node_modules\/iron-webcrypto/,
          /node_modules\/unenv/,
          /node_modules\/ohmyfetch/,
          /node_modules\/@webplatform\/asbis-ui/,
          /node_modules\/@webplatform\/dev-tools/,
          /node_modules\/@vueform\/multiselect/,
          /node_modules\/@shoelace-style/,
          /node_modules\/@lit/,
          /node_modules\/lit/,
          /node_modules\/lit-html/,
          /node_modules\/lit-element/
        ],
        use: {
          loader: "babel-loader",
          options: {
            presets: ["@babel/preset-env"],
            plugins: [
              "@babel/plugin-proposal-optional-chaining",
              "@babel/plugin-proposal-nullish-coalescing-operator",
              "@babel/plugin-proposal-class-properties",
              "@babel/plugin-proposal-unicode-property-regex",
              "@babel/plugin-transform-unicode-regex"
            ]
          }
        }
      });
      config.resolve.alias["node:process"] = "process";
    },
    postcss: {
      postcssOptions: {
        plugins: {
          tailwindcss: {},
          autoprefixer: {}
        }
      }
    }
  };
}
